import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	height: calc(100vh - 20px);
	overflow-y: scroll;

	h1#nonContent {
		align-self: flex-start;
	}
	.articleHeader {
		border-bottom: 2px dashed gray;
		padding-bottom: 5px;
		margin-bottom: 10px;
	}

	button {
		background-color: var(--main-blue);
		border: 2px solid var(--main-blue);
		width: 260px;
		padding: 10px;
		font-size: 18px;
		color: white;
		border-radius: 10px;
		float: right;
		transition: 300ms ease-in-out;
	}
	.button:hover {
		background-color: var(--dark-blue);
		border-color: var(--darkest-blue);
	}

	.input-area {
		display: flex;
		flex-direction: column;
		align-items: center;

		gap: 5px;
		margin-bottom: 20px;
	}
	.input-area input,
	.input-area textarea {
		width: 600px;
		min-height: 50px;
		border-radius: 10px;
		padding: 5px 10px;
		border: 2px solid var(--main-green);
	}
	.input-area textarea {
		min-height: 200px;
		height: max-content;
	}

	.input-area label {
		align-self: self-start;
		font-weight: 600;
	}

	.editArticles_button-area {
		button {
			background-color: var(--dark-green);
			border-color: var(--dark-green);
		}
		:hover {
			border-color: var(--main-green);
			background-color: var(--main-green);
		}

		margin-bottom: 20px;
	}

	.articles-area {
		margin-bottom: 20px;

		input,
		textarea {
			width: 400px;
		}

		h1 {
			font-size: 24px;
			margin-bottom: 10px;
		}

		ul {
			display: flex;
			flex-direction: column;
			margin-bottom: 30px;

			gap: 5px;

			#plusbutton,
			#trashButton {
				width: 40px;
				height: 40px;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				svg {
					font-size: 20px;
				}
			}

			#trashButton {
				width: 35px;
				height: 35px;
				background-color: red;
				border-color: red;

				svg {
					font-size: 18px;
				}
			}
		}

		li {
			div {
				display: flex;
				align-items: center;
				gap: 10px;
				input {
					width: 250px;
					border-radius: 10px;
					padding: 5px 10px;
				}
			}
		}

		.topic {
			li {
				list-style: disc;
			}
		}
		.numeric {
			li {
				list-style: decimal;
			}
		}
	}
`;
